// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2hg1t","content":"GlobalSearch_content__1AXoX"};